import { useTranslation } from "react-i18next";
import { paidSections } from "../../masterData";
import "./SectionContainer.scss";
function SectionItem(props) {
  const { sectionData, sectionType } = props;
  const [t, i18n] = useTranslation("common");

  const handleSectionClick = () => {
    props.setSection(sectionData.sectionId, sectionType);

    const element = document.getElementsByClassName(
      `basic-scroll-${sectionData.sectionId}`
    );
    setTimeout(() => {
      if (element && element[0]) {
        element[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }, 350);
    // props.handleClose();
  };

  return (
    <>
      {props.checkSectionPresentOrNot(sectionData.sectionId) && (
        <>
          <div>
            <div
              className="d-flex justify-content-between w-100 cursor mb-2"
              onClick={(e) => handleSectionClick()}
              style={{ fontSize: "14px" }}
            >
              <div style={{ fontSize: "14px" }}>
                {/* <img
                  src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/${sectionData.image}`}
                  alt="addicon"
                  className="img-add-section"
                /> */}
                <i
                  class={`${sectionData?.font_class} mr-2`}
                  aria-hidden="true"
                ></i>
                {t(`section.${sectionData.sectionId}`)}
              </div>
              {paidSections.includes(sectionData?.sectionId) ? (
                <div className="add-section-crown-icon">
                  <img className="w-100" src="./images/crown-black.png" />
                </div>
              ) : (
                <i class="fa fa-plus" aria-hidden="true"></i>
              )}
            </div>
            <div className="toolbox-separator"></div>
          </div>
          {/* <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <div className="d-flex justify-content-between w-100 cursor mb-2">
              <DummySection
                sectionId={sectionData.sectionId}
                sectionName={t(`section.${sectionData.sectionId}`)}
                handleSectionClick={handleSectionClick}
              />
            </div>
          </div> */}
        </>
      )}
    </>
  );
}

export default SectionItem;
